const types = {
    FIXED_FOOTER: 'FIXED_FOOTER',
    FIXED_FOOTER_CLEAR: 'FIXED_FOOTER_CLEAR',

    HOME_MSG: 'HOME_MSG',
    HOME_MSG_CLEAR: 'HOME_MSG_CLEAR',

    SHOW_HOME_MSG: 'SHOW_HOME_MSG',

    CONTENT_ACCESS: 'CONTENT_ACCESS',
    CONTENT_ACCESS_RESPONSE: 'CONTENT_ACCESS_RESPONSE',
    CONTENT_ACCESS_CLEAR: 'CONTENT_ACCESS_CLEAR',

    BREADCRUMB_STACK: 'BREADCRUMB_STACK',
    CLEAR_BREADCRUMB_STACK: 'CLEAR_BREADCRUMB_STACK',

    SECTION_LAZY_LOAD: 'SECTION_LAZY_LOAD',
    CLEAR_SECTION_LAZY_LOAD: 'CLEAR_SECTION_LAZY_LOAD',

    // Smart Bar Section
    SMART_BAR: 'SMART_BAR',
    SMART_BAR_RESPONSE: 'SMART_BAR_RESPONSE',
    SMART_BAR_CLEAR: 'SMART_BAR_CLEAR',

    // LOGING LOGO
    LOGIN_LOGO: 'LOGIN_LOGO',
    LOGIN_LOGO_RESPONSE: 'LOGIN_LOGO_RESPONSE',
    LOGIN_LOGO_CLEAR: 'LOGIN_LOGO_CLEAR',

    GOOGLE_CLIENT_ID: 'GOOGLE_CLIENT_ID',
    GOOGLE_CLIENT_ID_CLEAR: 'GOOGLE_CLIENT_ID_CLEAR',

    BLINK_LIVE: "BLINK_LIVE",
    BLINK_NOTIFICATION: "BLINK_NOTIFICATION",
    //Active Header

     // LOGING LOGO
     ACTIVE_HEADER: 'ACTIVE_HEADER',
     ACTIVE_HEADER_CLEAR: 'ACTIVE_HEADER_CLEAR',

     // LOGING LOGO
     SHOW_CHANGE_PASSWORD: 'SHOW_CHANGE_PASSWORD',
     SHOW_CHANGE_PASSWORD_CLEAR: 'SHOW_CHANGE_PASSWORD_CLEAR',

     //Loader
     SHOW_LOADER: "SHOW_LOADER",
     SHOW_LOADER_CLEAR:"SHOW_LOADER_CLEAR",

     //NEW CONTENT COUNT
     NEW_CONTENT_COUNT: "NEW_CONTENT_COUNT",
     NEW_CONTENT_COUNT_RESPONSE: "NEW_CONTENT_COUNT_RESPONSE",
     NEW_CONTENT_COUNT_RESPONSE_CLEAR: "NEW_CONTENT_COUNT_RESPONSE_CLEAR",

     //Language
       ACTIVE_LANGUAGE: 'ACTIVE_LANGUAGE',
       ACTIVE_LANGUAGE_CLEAR: 'ACTIVE_LANGUAGE_CLEAR',

       // LOGING LOGO
     IS_LOADING: 'IS_LADING',
     IS_LADING_CLEAR: 'IS_LADING_CLEAR',
}

export default types;